import React, { Fragment } from 'react';
import core from '@gin-betting/core';
import cd from 'debug';
import { createStructuredSelector } from 'reselect';

import { usePureSelector } from 'hooks';
import { State } from 'types';
import { getTopMarketComponentsBySport } from '../../../getTopMarkets';
import { selectTopMarketsByMatchId } from '../../../selectors';

const {
    utils: { checkEquality },
} = core;

const debug = cd('match-list:components:TopMarkets');

interface Props {
    matchId: string;
    hasMatchHeader: boolean;
    hasVS?: boolean;
    sportId: string;
    count: number;
    isDefaultName?: boolean;
    withStubs?: boolean;
}

const TopMarketsContainer: React.FC<Props> = props => {
    debug('render', props);

    const {
        hasMatchHeader,
        hasVS,
        sportId,
        count,
        matchId,
        isDefaultName,
        withStubs,
    } = props;

    const { topMarkets } = usePureSelector((s: State) =>
        selectProps(s, { matchId })
    );

    const topMarketComponentsBySport = getTopMarketComponentsBySport(sportId, {
        count,
        withStubs,
    });

    const commonProps = {
        hasMatchHeader,
        hasVS,
        matchId,
        isDefaultName,
    };

    const renderMarkets: JSX.Element[] = [];

    topMarketComponentsBySport.reduce((acc, item, idx) => {
        const { nextMarkets, ReactNode } = item(acc, commonProps, idx);
        renderMarkets.push(ReactNode);

        return nextMarkets;
    }, topMarkets);

    return <Fragment>{renderMarkets}</Fragment>;
};

const selectProps = createStructuredSelector({
    topMarkets: selectTopMarketsByMatchId,
});

export default React.memo(TopMarketsContainer, (prevProps, nextProps) =>
    checkEquality(prevProps, nextProps, {
        maxDepth: 3,
        excludedKeys: ['odds', 'specifiers'],
    })
);
